export const normalizeTag = (tagName = '') =>
  tagName?.toString().trim().toLowerCase().replace(/\s+/g, '_');

const getTagNames = (stories = []) =>
  stories.flatMap((story) =>
    story.tipsheet_tile_json?.tags
      ?.map((tag) => tag.tagname)
      .filter(Boolean) || []
  );

export const getUniqueTags = (
  stories = [],
  { normalize = true, excludeUnknown = true } = {}
) => {
  const tags = getTagNames(stories).map((tagname) =>
    normalize ? normalizeTag(tagname) : tagname
  );

  const uniqueTags = Array.from(new Set(tags)).filter(Boolean);

  return normalize && excludeUnknown
    ? uniqueTags.filter((tag) => tag !== 'unknown')
    : uniqueTags;
};

export const getUniqueRawTags = (stories = []) =>
  getUniqueTags(stories, { normalize: false, excludeUnknown: false });

export const getUniqueNormalizedTags = (stories = []) =>
  getUniqueTags(stories, { normalize: true, excludeUnknown: true });
